// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"6ae57c17","455":"7d3338dc","977":"2a555d66"}[chunkId] + ".chunk.js";
};